module.exports = __webpack_public_path__ + "media/subAraResumen.615ee2b7.mp4";